attachEvent('.copy-button', 'click', (ev) => {
  navigator.clipboard.writeText(window.location.href);

  ev.target.closest('.copy-button').classList.add('is-copied');
  setTimeout(() => {
    ev.target.closest('.copy-button').classList.remove('is-copied');
  }, 2000);
});
